__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/0cf1b1f/_next/";